import "./flipcard.scss";
import NickNameFlag from "./NickNameFlag";
import icons from "../../helpers/iconMenu";
import React, { useRef, useState } from "react";
import { Storage } from "../../apiHelper/Storage";
import { getStaticText } from "../../lables/lablesService";
import useOnclickOutside from "../../hooks/useOnclickOutside";

const storage = Storage();

const FlipCard = ({
  service,
  user_info,
  closeCard,
}) => {
  //Ref element
  const ref = useRef();
  //State for card flip
  const [flip, setFlip] = useState(false);
  //Custom hook
  useOnclickOutside(ref, () => setFlip(false));
  //State for input admin checked
  const [updateUserData, setUpdateUserData] = useState({
    ...user_info,
    active: user_info.active,
    employee: user_info.employee
  });
  //My user id
  const me = storage.get('user')

  const handleChekedValueActiveUser = async e => {
    let savedDataActive = null;

    if (updateUserData.open_user_id) {
      savedDataActive = await service.toggle_admin_active(updateUserData.open_user_id);

      if (savedDataActive.error) {
        window.alert(savedDataActive.errors.length ? savedDataActive.errors[0] : getStaticText('save_error'));
      }
    }

    if (!savedDataActive.error) {
      window.alert(getStaticText('save_success'));
      setUpdateUserData(prev => ({
        ...prev,
        active: e.target.checked ? 0 : 1
      }));
    }
  }

  const handleChekedValueAdmin = async e => {
    let savedDataAdmin = null;

    if (updateUserData.open_user_id) {
      savedDataAdmin = await service.toggle_employee_active(updateUserData.open_user_id)

      if (savedDataAdmin.error) {
        window.alert(savedDataAdmin.errors.length ? savedDataAdmin.errors[0] : getStaticText('save_error'));
      }
    }

    if (!savedDataAdmin.error) {
      window.alert(getStaticText('save_success'));
   
      setUpdateUserData(prev => ({
        ...prev,
        employee: e.target.checked ? 0 : 1
      }));
    }
  }

  //Method flip card open/close
  const flipCard = () => setFlip(prev => !prev);

  return (
    <div ref={ref} className={`flip-card ${flip !== true ? "front-flip" : "back-flip"}`}>
      <div className="flip-card-inner">

        {/* Render flip card front */}
        <div className="flip-card-front">
          <NickNameFlag nick_name={user_info.family_name} />
          <div className="flip_img">
            <img src={user_info.picture} alt='img' />
          </div>
          <div className="pt-5">
            <button
              onClick={flipCard}
              className="btn btn-outline-warning pt-0 pb-0 shadow-none"
            >
              {getStaticText('u_btn_info')}
            </button>
          </div>
          <div className="action-btns">
            <span>
              {user_info.given_name} {" "}
              {user_info.middle_name === "null" ? getStaticText('u_empty_middle_name') : user_info.middle_name}</span>
            <button
              onClick={closeCard}
              className="btn btn-danger btn_exit"
            >
              <i className={icons.news_remove_icon} />
            </button>
          </div>
        </div>

        {/* Render flip card back */}
        <div className="flip-card-back">
          <div
            onClick={flipCard}
            className="btn btn-warning p-0 text-white btn_flip"
          >
            <i className={icons.arrow_flip_back} />
          </div>
          <div className="p-1 flip_box">
            <p className="d-flex m-1 justify-content-between">
              <span>{getStaticText('flip_beck_id')}</span>
              <span className="text-left">{user_info.id}</span>
            </p>
            <p className="d-flex m-1  justify-content-between">
              <span>{getStaticText('flip_beck_name')}</span>
              <span>{user_info.given_name}</span>
            </p>
            <p className="d-flex m-1 justify-content-between">
              <span>{getStaticText('flip_beck_second_name')}</span>
              <span>{user_info.family_name}</span>
            </p>
            <p className="d-flex m-1 justify-content-between">
              <span>{getStaticText('flip_beck_last_name')}</span>
              <span>
                {user_info.middle_name === "null" ? getStaticText('u_empty_middle_name') : user_info.middle_name}
              </span>
            </p>
          </div>
          <div className="mt-4">
            <div className="d-flex m-2">
              <input
                type="checkbox"
                className="flip_checkbox"
                checked={updateUserData.active}
                onChange={handleChekedValueActiveUser}
                disabled={me?.id === user_info.open_user_id}
              />
              <span className="m-1">{getStaticText('flip_beck_active')}</span>
            </div>
            <div className="d-flex m-2">
              <input
                type="checkbox"
                className="flip_checkbox"
                checked={updateUserData.employee}
                onChange={handleChekedValueAdmin}
                disabled={me?.id === user_info.open_user_id}
              />
              <span className="m-1">{getStaticText('flip_beck_admin')}</span>
            </div>
          </div>
        </div>

      </div>
    </div >
  );
}

export default FlipCard;